export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '86c1a9c4-d547-4089-bf88-16fdc32065e5',
      authority: 'https://login.microsoftonline.com/7124e463-2734-41bf-bddb-3e475374f94c',
    },
  },
  apiConfig: {
    scopes: ['openid', 'api://06b22e54-9aa0-4f07-a51e-348bd63dea84/api.all'],
    uri: 'https://d-ksa-common-euw-apim.azure-api.net/at/api',
    subscriptionKey: 'fb3e91d35e814544aae3fe8215765238',
  },
};
